import { Link } from 'react-router-dom';
import { EntrySettings } from '@/api/types/entry-types';
import { EntryAccessLock } from './EntryAccessLock';

interface EntryData {
  title?: string;
  community?: {
    id: string;
  };
  settings?: EntrySettings;
}

interface EntryTitleProps {
  type: string;
  entry: EntryData;
  makeUrl: () => string;
  canEdit: boolean;
}

function EntryTitle({ entry, makeUrl, canEdit }: EntryTitleProps) {
  const isCommunity = entry.community !== undefined;
  const hasLockIcon = Boolean(entry.settings?.permissions?.access?.length);
  const { title } = entry;

  return (
    <>
      {(title || hasLockIcon) && (
        <div className="blog-entry-title">
          {hasLockIcon && entry.settings?.permissions && (
            <EntryAccessLock
              permissions={entry.settings.permissions}
              isCommunity={isCommunity}
              canEdit={canEdit}
            />
          )}
          <Link to={makeUrl()} data-testid="blog-entry-title-link">
            {title}
          </Link>
        </div>
      )}
    </>
  );
}
export default EntryTitle;
